import { withTheme } from "styled-components";
import type { RuntimeTheme } from "../../../lib/theme/theme";
import type { ScrollInfo } from "../scroll-reactive-component/scroll-reactive-component";
import { ScrollReactiveComponent } from "../scroll-reactive-component/scroll-reactive-component";
import { CollapserStyle, Container, Wrapper } from "./collapse-bar-style";

interface Props {
    collapser: React.ReactNode;
    theme: RuntimeTheme;
    children: React.ReactNode;
    scrollID: string;
}
interface State {
    scrollPosition: number;
}

class CollapseBar extends ScrollReactiveComponent<Props, State> {
    public state: State = {
        scrollPosition: 0,
    };

    protected onScrollChanged(scrollInfo: ScrollInfo) {
        const { scrollID } = this.props;
        const { id } = scrollInfo;

        // We only want to subscribe the screen we are scrolling
        if (scrollID !== id) return;

        const newPosition = -Math.min(scrollInfo.position, this.props.theme.navBar.largeTitleHeight);
        if (newPosition !== this.state.scrollPosition) {
            this.setState({ scrollPosition: newPosition });
        }
    }

    public render(): React.ReactNode {
        return (
            <Container>
                <Wrapper translateAmount={this.state.scrollPosition}>
                    <CollapserStyle>{this.props.collapser}</CollapserStyle>
                    {this.props.children}
                </Wrapper>
            </Container>
        );
    }
}

export default withTheme(CollapseBar);
